import React from 'react';
import { Box, Button } from '@curves/ui-base';

import PropTypes from 'prop-types';
const Actions = ({ actions, ...rest }) => {
    return (
        <Box className="btn-group" {...rest}>
            {actions.map(({ label, variant = 'outlined', onClick, ...rest }) => (
                <Button key={label} variant={variant} onClick={onClick} {...rest} color="primary">
                    {label}
                </Button>
            ))}
        </Box>
    );
};
Actions.prototype = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
            onClick: PropTypes.func.isRequired,
        }),
    ),
};
export default Actions;
